import { useTranslation } from 'react-i18next';

import Separator from '../../../../components/Separator/Separator';

import type {
  IInsightsDashboardItem, IInsightsDashboardResponse,
} from '../../../../store/slices/survey/interfaces/IInsightsDashboardResponse';

import styles from '../scss/MAInsightsDashboardRank.module.scss';

function InsightsDashboardChart({
  dashboardData,
}: { dashboardData: IInsightsDashboardResponse }) {
  const { t } = useTranslation();
  const data = (dashboardData?.global && dashboardData?.global.length > 0) ? dashboardData?.global : [];

  return (
    <div className={styles.rankWrapper}>
      <p className={styles.header}>{t('materialityAssessment.ranking')}</p>
      {data.map((item: IInsightsDashboardItem, index: number) => (
        <div key={item.standardName} className={styles.rankItem}>
          <span className={styles.rankNumber}>{index + 1}</span>
          .
          <span className={styles.rankNumber}>{item?.standardName}</span>
          -
          <span className={styles.rankNumber}>{item.title}</span>
          {index + 1 !== dashboardData.global.length ? <Separator className={styles.separator} /> : null}
        </div>
      ))}
    </div>
  );
}

export default InsightsDashboardChart;
